// Third-party
import Grid from '@mui/material/Grid2';
import SvgIcon from '@mui/material/SvgIcon';
import Typography from '@mui/material/Typography';

// Components
import Box from '@mui/material/Box';
import { useTheme } from '@mui/material';
import { TCustomTheme } from '@mgm/common/theme';
import { useCustomTheme } from '@mgm/common/hooks/useCustomTheme';
import { TotalIconWrapper } from '../../Shared';
import { TotalCard } from '../../../../components';

// Hooks
import { useSubmissions } from '../hooks';

const SubmissionsTotals = () => {
  const { getTotalItems } = useSubmissions();
  const theme = useTheme() as TCustomTheme;
  const { isMobile } = useCustomTheme(theme);

  return (
    <Grid container spacing={3}>
      {getTotalItems.map((item) => (
        <Grid
          key={item.title}
          size={{
            lg: 4,
            md: 4,
            xs: 12,
            sm: 6,
          }}
        >
          <TotalCard background={item.cardBg} color={item.cardColor}>
            <Box
              {...(isMobile && {
                px: 2,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
              })}
            >
              <TotalIconWrapper sx={{
                mx: isMobile ? 0 : 'auto',
                backgroundImage: item.iconBg,
                iconColor: item.cardColor,
              }}
              >
                <SvgIcon fontSize="large" component={item.icon} inheritViewBox />
              </TotalIconWrapper>
              <Box>
                <Typography variant="h3">{item.value}</Typography>
                <Typography variant="subtitle2" sx={{ opacity: 0.72 }}>
                  {item.title}
                </Typography>
              </Box>
            </Box>
          </TotalCard>
        </Grid>
      ))}
    </Grid>
  );
};

export {
  SubmissionsTotals,
};
